module.exports = __webpack_public_path__ + "af722f086f01c940902ec5330b87113e.png";